import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axiosRateGroup from 'app/api/apiRateGroup';
import PaginationModel from 'app/utils/PaginationApiModel';

export const getRateGroups = createAsyncThunk('commonAPI/RateGroups/getRateGroup', async () => {
   const params = PaginationModel.PageSize9999ApiModel();
   const response = await axiosRateGroup.apiRateGroup.list({ ...params });
   const data = await response.data;
   return data === undefined ? null : data;
});

const rateGroupCommonDataAdapter = createEntityAdapter({
   selectId: (rateGroup) => rateGroup.iId,
});

export const { selectAll: selectRateGroupsCommon } = rateGroupCommonDataAdapter.getSelectors((state) => state.commonAPI.rateGroups.dataRateGroups);

const rateGroupsCommonSlice = createSlice({
   name: 'rateGroups',
   initialState: {
      dataRateGroups: rateGroupCommonDataAdapter.getInitialState(),
   },
   reducers: {
      setLoading: {
         reducer: (state, action) => {
            state.loading = action.payload;
         },
      },
   },
   extraReducers: {
      [getRateGroups.fulfilled](state, { payload }) {
         rateGroupCommonDataAdapter.setAll(state.dataRateGroups, payload);
         const newEmptyValue = { iId: '', SName: '' };
         rateGroupCommonDataAdapter.addOne(state.dataRateGroups, newEmptyValue);
      },
   },
});

export const { setLoading } = rateGroupsCommonSlice.actions;

export default rateGroupsCommonSlice.reducer;
